// Declarations Information related Redux Constants
export const [
  DECLARATIONS_STATEMENTS_SAVE
] = [
  "DECLARATIONS_STATEMENTS_SAVE"
];
